import { getErrorCode, getTranslatedErrorMessage } from '@/helpers/apiErrors';
import { invalid_sms_code, sms_code_expired } from '../locale.json';
import handleApiInvalidPasswordErrorIfPresent from '../handleApiInvalidPasswordErrorIfPresent';

export default async function () {
  const p = this.$store.dispatch('auth/resetPassword', {
    phone: this.phone,
    phone_country: this.phone_country,
    code: this.code,
    password: this.password,
  });

  try {
    await p;
  } catch (err) {
    if (handleApiInvalidPasswordErrorIfPresent.call(this, err)) {
      return
    }

    const errorMessage = getTranslatedErrorMessage(err)

    if (errorMessage) {
      this.error = errorMessage

      return
    }

    const errorCode = getErrorCode(err)

    if (errorCode === 'auth.password_reset.code_expired') {
      this.error = sms_code_expired

      return
    } else if (errorCode === 'auth.password_reset.invalid_code') {
      this.error = invalid_sms_code

      return
    }

    throw err;
  }

  this.page = 'done:resetPassword';
};
